import { IconComponent } from './types';

const rotation = {
  up: 'rotate(0deg)',
  down: 'rotate(180deg)',
  left: 'rotate(-90deg)',
  right: 'rotate(90deg)',
} as const;

const ArrowIcon: IconComponent<{
  direction?: keyof typeof rotation;
}> = (props) => {
  const { direction = 'up', style = {} } = props;
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ ...style, transform: rotation[direction] }}
      {...props}
    >
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.46447 4.82841L5.64645 1.64642C5.84171 1.45116 6.1583 1.45116 6.35356 1.64642L9.53554 4.82841C9.7308 5.02367 9.7308 5.34025 9.53554 5.53551C9.34028 5.73077 9.02369 5.73077 8.82843 5.53551L6.5 3.20708V10.0347H5.5V3.20708L3.17158 5.53551C2.97631 5.73077 2.65973 5.73077 2.46447 5.53551C2.26921 5.34025 2.26921 5.02367 2.46447 4.82841Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export default ArrowIcon;
